import $ from "jquery";
import { defer } from "lodash";
import { View } from "backbone";
/* eslint-disable
    constructor-super,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Base class for large tooltips. So we don't duplicate all the core methods every time.
let LargeTooltipView;
export default LargeTooltipView = class LargeTooltipView extends View {
  initialize(options) {
    this._listenToOutsideClick = this._listenToOutsideClick.bind(this);
    return super.initialize(options);
  }

  show() {
    return this.$el.show();
  }

  hide() {
    return this.$el.hide();
  }

  toggle() {
    if (this.$el.is(":visible")) {
      return this.hide();
    }
    this.show();

    return this._listenToOutsideClick();
  }

  // Close popup if user clicks or focuses anywhere other than inside the popup
  _listenToOutsideClick() {
    return defer(() => {
      const cls = this.$el[0].className.split(" ")[0];

      return $("body").one("click.tooltip focusin.tooltip", (event) => {
        if ($(event.target).hasClass(cls) || ($(event.target).parents(`.${cls}`).length > 0)) {
          return this._listenToOutsideClick();
        }
        $("body").off("click.tooltip focusin.tooltip");

        return this.hide();
      });
    });
  }
};
